import { Component, Injector, Input, OnInit } from '@angular/core';

import { ChassisFormHandler } from '@kaiser-software/chassis-core';
import { AddressModel } from '../../models/address.model';

@Component({
    selector: 'addresses-address-form',
    templateUrl: './address-form.component.html',
    styleUrls: [ './address-form.component.scss' ]
})
export class AddressFormComponent implements OnInit {

    @Input() public address: AddressModel;

    public form: ChassisFormHandler;

    constructor(protected injector: Injector) {
    }

    ngOnInit() {
        this.form = new ChassisFormHandler(this.injector, 'address', this.address);
    }

}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/addresses/components/address-form/address-form.component.ts